// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"629":"9c055dd3","934":"0c63c341"}[chunkId] + ".chunk.css";
};